module.exports = __webpack_public_path__ + "img/arrow.130b7902.svg";